/**
 * Created by i.lovenkov on 25.04.17.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactRouter = require('react-router');

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    NotificationView: {
        displayName: 'NotificationView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Notification/default/NotificationView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var NotificationView = _wrapComponent('NotificationView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(NotificationView, _Component);

    function NotificationView(props) {
        (0, _classCallCheck3.default)(this, NotificationView);
        return (0, _possibleConstructorReturn3.default)(this, (NotificationView.__proto__ || (0, _getPrototypeOf2.default)(NotificationView)).call(this, props));
    }

    (0, _createClass3.default)(NotificationView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                iconClassName = _props.iconClassName,
                isLink = _props.isLink,
                onClick = _props.onClick,
                lang = _props.lang;


            if (isLink) {
                return _react3.default.createElement(
                    _reactRouter.Link,
                    {
                        className: className || '',
                        onClick: onClick,
                        title: lang['store.notification.empty_fields'],
                        to: '/personal/profile'
                    },
                    _react3.default.createElement('i', { className: 'fa fa-exclamation-circle login_warning_icon' + (' ' + iconClassName || '') })
                );
            }

            return _react3.default.createElement(
                'span',
                {
                    className: className || '',
                    title: lang['store.notification.empty_fields']
                },
                _react3.default.createElement('i', { className: 'fa fa-exclamation-circle login_list_warning_icon' + (' ' + iconClassName || '') })
            );
        }
    }]);
    return NotificationView;
}(_react2.Component), _class.propTypes = {
    className: _react2.PropTypes.string,
    iconClassName: _react2.PropTypes.string,
    onClick: _react2.PropTypes.func.isRequired,
    isLink: _react2.PropTypes.bool.isRequired,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = NotificationView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/default/NotificationView.jsx
// module id = 1696
// module chunks = 0